import { addDays, endOfWeek, format, startOfWeek } from "date-fns";
import { getEvents } from "../../../services/events";
import * as actionTypes from "./constants";

const addSportsEventsAction = (events) => ({
  type: actionTypes.ADD_MORE_EVENTS,
  events: events,
});

const emptyAndAddSportsEventsAction = (events) => ({
  type: actionTypes.EMPTY_ADD_MORE_EVENTS,
  events: events,
});

export const getSportsEventsAction = (
  pagenum = 1,
  city = {},
  sortMode,
  cancelSource,
  categories,
  intervalType,
  startdt,
  enddt
) => {
  const getInterval = (intervalType, startdt, enddt) => {
    /**
     * 0: Any Dates
     * 1:This Weekend
     * 2:Next Weekend
     * 3:Next 7 Days
     * 4:Next 30 Days
     * 5:Next 60 Days
     * 6:Custom
     */
    const today = new Date();

    switch (intervalType) {
      case "0":
        return { startdt: undefined, enddt: undefined };
      case "1":
        const monday = startOfWeek(today, { weekStartsOn: 1 });
        const sunday = endOfWeek(today, { weekStartsOn: 1 });

        return {
          startdt: format(monday, "yyyy-MM-dd"),
          enddt: format(sunday, "yyyy-MM-dd"),
        };

      case "2":
        const nextMonday = addDays(startOfWeek(today, { weekStartsOn: 1 }), 7);
        const nextSunday = addDays(endOfWeek(today, { weekStartsOn: 1 }), 7);

        return {
          startdt: format(nextMonday, "yyyy-MM-dd"),
          enddt: format(nextSunday, "yyyy-MM-dd"),
        };
      case "3":
        const next7day = addDays(today, 7);

        return {
          startdt: format(today, "yyyy-MM-dd"),
          enddt: format(next7day, "yyyy-MM-dd"),
        };
      case "4":
        const next30day = addDays(today, 30);

        return {
          startdt: format(today, "yyyy-MM-dd"),
          enddt: format(next30day, "yyyy-MM-dd"),
        };

      case "5":
        const next60day = addDays(today, 60);

        return {
          startdt: format(today, "yyyy-MM-dd"),
          enddt: format(next60day, "yyyy-MM-dd"),
        };
      case "6":
        return {
          startdt: startdt instanceof Date ? format(startdt, "yyyy-MM-dd") : "",
          enddt: enddt instanceof Date ? format(enddt, "yyyy-MM-dd") : "",
        };

      default:
        break;
    }
    return { startdt: undefined, enddt: undefined };
  };

  const subcategory = categories.map((ele) => ele.keyWord).join(",");
  const interval = getInterval(intervalType, startdt, enddt);

  const category = "SPORTS";

  return (dispatch) => {
    getEvents(
      pagenum,
      city,
      sortMode,
      category,
      subcategory,
      interval.startdt,
      interval.enddt,
      (events) => {
        dispatch(getChangeSportsPagenumAction(pagenum));
        if (pagenum === 1) {
          dispatch(emptyAndAddSportsEventsAction(events));
        } else {
          dispatch(addSportsEventsAction(events));
        }
      },
      cancelSource
    );
  };
};

const changeSportsPagenum = (pagenum) => ({
  type: actionTypes.CHANGE_PAGENUM,
  pagenum: pagenum,
});

export const getChangeSportsPagenumAction = (pagenum) => {
  return (dispatch) => {
    dispatch(changeSportsPagenum(pagenum));
  };
};

const changeSportsLayoutMode = (layoutMode) => ({
  type: actionTypes.CHANGE_LAYOUT_MODE,
  layoutMode: layoutMode,
});

export const getChangeSportsLayoutModeAction = (layoutMode) => {
  return (dispatch) => {
    dispatch(changeSportsLayoutMode(layoutMode));
  };
};

// 修改排序
const changeSportsSortMode = (sortMode) => ({
  type: actionTypes.CHANGE_SORT_MODE,
  sortMode: sortMode,
});

export const getChangeSportsSortModeAction = (sortMode) => {
  return (dispatch) => {
    dispatch(changeSportsSortMode(sortMode));
  };
};

// 筛选分类
const changeSportsCategories = (categories) => ({
  type: actionTypes.CHANGE_CATEGORIES,
  categories: categories,
});

export const getChangeSportsCategoriesAction = (categories) => {
  return (dispatch) => {
    dispatch(changeSportsCategories(categories));
  };
};

// 时间段
const changeSportsTemporalInterval = (
  intervalType,
  startdt = null,
  enddt = null
) => ({
  type: actionTypes.CHANGE_TEMPORAL_INTERVAL,
  intervalType: intervalType,
  startdt: startdt,
  enddt: enddt,
});

export const getChangeSportsTemporalIntervalAction = (
  intervalType,
  startdt = null,
  enddt = null
) => {
  return (dispatch) => {
    dispatch(changeSportsTemporalInterval(intervalType, startdt, enddt));
  };
};
